import { render, staticRenderFns } from "./moveRecord.vue?vue&type=template&id=38d344db&scoped=true&"
import script from "./moveRecord.vue?vue&type=script&lang=js&"
export * from "./moveRecord.vue?vue&type=script&lang=js&"
import style0 from "./moveRecord.vue?vue&type=style&index=0&id=38d344db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d344db",
  null
  
)

export default component.exports